import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { CategoryDTO } from "src/app/models/Categories/categoryDTO";

export const getCategories = createAction(
  "[Categories] Get All Categories Action",
  props<{ options: any }>()
);
export const loadCategories = createAction(
  "[Categories] Load All Categories Action",
  props<{ response: any[] }>()
);
export const getExcelCategories = createAction(
  "[Categories] Get All Excel Categories Action",
  props<{ options: any }>()
);
export const loadExcelCategories = createAction(
  "[Categories] Load All Excel Categories Action",
  props<{ response: any[] }>()
);
export const getCategoryUsages = createAction(
  "[Categories] Get All Category Usages Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadCategoryUsages = createAction(
  "[Categories] Load All Category Usages Action",
  props<{ response: any[] }>()
);
// Table Configuration Settings
export const getCategoriesTableConfig = createAction(
  "[Categories] Get Categories Table Configuration Action",
  props<{ options: any }>()
);
export const loadCategoriesTableConfig = createAction(
  "[Categories] Load Categories Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveCategoriesTableConfig = createAction(
  "[Categories] Save Categories Table Configuration Action",
  props<{ config: any }>()
);
export const getCategory = createAction(
  "[Categories] Get Category Action",
  props<{ code: string }>()
);
export const loadCategory = createAction(
  "[Categories] Load Category Action",
  props<{ response: any }>()
);
export const getCategoryElements = createAction(
  "[Categories] Get Category Elements Action",
  props<{ code: string }>()
);
export const loadCategoryElements = createAction(
  "[Categories] Load Category Elements Action",
  props<{ response: any[] }>()
);
export const createCategory = createAction(
  "[Categories] Create Category Action",
  props<{ category: CategoryDTO }>()
);
export const updateCategory = createAction(
  "[Categories] Update Card Action",
  props<{ category: CategoryDTO }>()
);
export const resetCategory = createAction("[Categories] Reset Category Action");
export const setCategory = createAction(
  "[Categories] Set Category Action",
  props<{ category: CategoryDTO }>()
);
export const createCategoryElements = createAction(
  "[Categories] Create Category Elements Action ",
  props<{ categoryCode: string; categoryElements: any[] }>()
);
export const deleteCategoryElements = createAction(
  "[Categories] Delete Category Elements Action ",
  props<{ categoryCode: string; categoryElements: any[] }>()
);
export const resetCategorieState = createAction(
  "[Categories] Reset Categories State Action"
);
export const resetCreation = createAction("[Categories] Reset Creation Action");
export const getLoadingState = createAction(
  "[Categories] Get Card Loading State Action"
);
export const setLoadingStartState = createAction(
  "[Categories] Set Card Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[Categories] Set Card Loading End State Action"
);
